import {useMemo} from 'react';
import {BrowserRouter} from 'react-router-dom';
import {i18n} from '@app/configs/i18n';
import {appThemeFactory} from '@app/configs/theme/appTheme';
import {IsMobileProvider} from '@shared/lib/mobile/ui/Provider';
import {ConfigProvider} from 'antd';
import {I18nProvider} from './providers/i18n';
import {NotificationProvider} from './providers/notifications';
import {QueryProvider} from './providers/query';
import {Router} from './providers/router';
import {useAppTheme} from './providers/theme';
import {GlobalStyles} from './styles/globalStyles';

i18n.init();

// Declare VETCOI as global variables from script tags
declare global {
  const VETCOIWakeWord: any;
  const VETCOIModel: any;

  interface Window {
    VETCOIWakeWord: any;
    VETCOIModel: any;
  }
}

const App = () => {
  const {isDark} = useAppTheme();

  const theme = useMemo(() => appThemeFactory({isDark}), [isDark]);

  return (
    <QueryProvider>
      <I18nProvider>
        <BrowserRouter>
          <ConfigProvider theme={theme}>
            <NotificationProvider>
              <IsMobileProvider>
                <GlobalStyles isDark={isDark}/>
                <Router/>
              </IsMobileProvider>
            </NotificationProvider>
          </ConfigProvider>
        </BrowserRouter>
      </I18nProvider>
    </QueryProvider>
  );
};

export {App};
